import type { BannerInlineFragment } from '@seek/cmsu-cms-connect';
import {
  Columns,
  Column,
  Stack,
  Box,
  Badge,
  Hidden,
} from 'braid-design-system';
import React from 'react';
import { ActionGroup } from '../../ActionGroup/ActionGroup';
import { Asset } from '../../Asset/Asset';
import { Heading } from '../../Heading/Heading';
import { Paragraph } from '../../Paragraph/Paragraph';
import { BannerDivider } from '../BannerDivider';

type Props = Pick<
  BannerInlineFragment,
  | 'reverse'
  | 'image'
  | 'heading'
  | 'paragraph'
  | 'actionGroup'
  | 'inlineDivider'
  | 'badge'
>;

const MAX_IMAGE_HEIGHT = '300px';
const MAX_IMAGE_HEIGHT_MOBILE = '125px';

export const InlineBanner = ({
  actionGroup,
  heading,
  paragraph,
  reverse,
  image,
  inlineDivider,
  badge,
}: Props) => (
  <Box data-testid="inlineBannerTestId" padding="small">
    <Columns
      space={{ mobile: 'gutter', tablet: 'xlarge' }}
      alignY="center"
      collapseBelow="tablet"
      reverse={reverse || false}
    >
      <Column>
        {image && (
          <>
            <Hidden below="tablet">
              <Asset {...image} style={{ maxHeight: MAX_IMAGE_HEIGHT }} />
            </Hidden>
            <Hidden above="mobile">
              <Asset
                {...image}
                style={{ maxHeight: MAX_IMAGE_HEIGHT_MOBILE }}
              />
            </Hidden>
          </>
        )}
      </Column>
      <Column>
        <Stack space="gutter">
          {badge && (
            <Badge {...badge} weight="strong">
              {badge.text}
            </Badge>
          )}
          {heading && <Heading {...heading} />}
          {paragraph && (
            <Paragraph content={paragraph.Paragraph_text?.raw} {...paragraph} />
          )}
          {actionGroup && (
            <ActionGroup {...actionGroup} size={actionGroup.actionGroupSize} />
          )}
          {inlineDivider && (
            <BannerDivider
              image={inlineDivider.image}
              actions={inlineDivider}
            />
          )}
        </Stack>
      </Column>
    </Columns>
  </Box>
);
